import { render } from "./CampaignTargeting.vue?vue&type=template&id=04a45b86"
import script from "./CampaignTargeting.vue?vue&type=script&lang=js"
export * from "./CampaignTargeting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__